import React from 'react';
import { TextField } from '@mui/material';
import type { DayRange } from '../utils/dateRangeParams';
import { FILTER_TEXT_SX } from '../constants/formLayout';

interface DateRangeFilterProps {
  value: DayRange;
  onChange: (range: DayRange) => void;
}

/**
 * Filter-row text (14px). The browser's calendar icon is solid black; at MUI's
 * `action.active` opacity (0.54) it matches the dropdown arrows in the same row.
 */
const DATE_FIELD_SX = { ...FILTER_TEXT_SX, '& input::-webkit-calendar-picker-indicator': { opacity: 0.54 } } as const;

/** "From" and "To" calendar days. Each bounds the other, so a range can't run backwards. */
const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ value, onChange }) => (
  <>
    <TextField
      label="From"
      type="date"
      size="small"
      sx={DATE_FIELD_SX}
      value={value.from}
      onChange={(event) => onChange({ ...value, from: event.target.value })}
      slotProps={{ inputLabel: { shrink: true }, htmlInput: { max: value.to || undefined } }}
    />
    <TextField
      label="To"
      type="date"
      size="small"
      sx={DATE_FIELD_SX}
      value={value.to}
      onChange={(event) => onChange({ ...value, to: event.target.value })}
      slotProps={{ inputLabel: { shrink: true }, htmlInput: { min: value.from || undefined } }}
    />
  </>
);

export default DateRangeFilter;
